import 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Modal } from '@cbhq/cds-web/overlays/Modal/Modal';
import { ModalHeader } from '@cbhq/cds-web/overlays/Modal/ModalHeader';
import messages from './messages.js';
import './screens/index.js';
import { SCREEN_IDS, useGlobalPreferenceNavigation } from './useGlobalPreferenceNavigation.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import GlobalPreferenceScreens from './screens/screens.js';
const mainScreenId = SCREEN_IDS.main;
function GlobalPreferencesModal({
  screenId,
  onRequestClose,
  countryCode,
  countryCodeFromIP,
  languageCode,
  localeInformation,
  localeFromUrl
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useGlobalPreferenceN = useGlobalPreferenceNavigation(screenId || mainScreenId),
    currentScreen = _useGlobalPreferenceN.currentScreen,
    navigateTo = _useGlobalPreferenceN.navigateTo,
    goBack = _useGlobalPreferenceN.goBack,
    canGoBack = _useGlobalPreferenceN.canGoBack;
  return /*#__PURE__*/jsxs(Modal, {
    visible: true,
    onRequestClose: onRequestClose,
    children: [/*#__PURE__*/jsx(ModalHeader, {
      title: currentScreen ? currentScreen.title : '',
      closeAccessibilityLabel: formatMessage(messages.closeA11yLabel),
      onBackButtonPress: canGoBack ? goBack : undefined,
      backAccessibilityLabel: canGoBack ? formatMessage(messages.backA11yLabel) : undefined
    }), /*#__PURE__*/jsx(ScrollContainer, {
      children: /*#__PURE__*/jsx(GlobalPreferenceScreens, {
        currentScreen: currentScreen,
        navigateTo: navigateTo,
        countryCode: countryCode,
        languageCode: languageCode,
        countryCodeFromIP: countryCodeFromIP,
        localeInformation: localeInformation,
        localeFromUrl: localeFromUrl
      })
    })]
  });
}
const ScrollContainer = styled.div`
  display: flex;
  max-height: 578px;
  overflow: scroll;

  /* firefox */
  scrollbar-width: none;
  /* chrome */
  &::-webkit-scrollbar {
    display: none;
  }
`;
export { GlobalPreferencesModal as default };
//# sourceMappingURL=GlobalPreferencesModal.js.map
